import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let RowsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-rows';
        }
    }
});
export const RowsPlugin = {
    name: 'e-rows',
    install(Vue) {
        Vue.component(RowsPlugin.name, RowsDirective);
    }
};
export let RowDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-row';
        }
    }
});
export const RowPlugin = {
    name: 'e-row',
    install(Vue) {
        Vue.component(RowPlugin.name, RowDirective);
    }
};
